var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('el-container',[(_vm.showHeader)?_c('el-header',[_c('Header',{attrs:{"active_index":_vm.active_index}})],1):_vm._e(),_c('el-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }